// ./src/contexts/EventArtistsContext/EventArtistsContext.tsx
//
// Thin context wrapper around useEventArtists (an event's artist bookings /
// lineup). Mount with initialFilters={{ eventId: [eventId] }}. See PartnersContext.

import React, { createContext, useContext } from "react";

import { useEventArtists, UseEventArtistsOptions, UseEventArtistsReturn } from "@/hooks/useEventArtists";

const EventArtistsContext = createContext<UseEventArtistsReturn | null>(null);

export interface EventArtistsProviderProps extends UseEventArtistsOptions {
  children: React.ReactNode;
}

export const EventArtistsProvider: React.FC<EventArtistsProviderProps> = ({ children, ...options }) => {
  const value = useEventArtists(options);

  return <EventArtistsContext.Provider value={value}>{children}</EventArtistsContext.Provider>;
};

export const useEventArtistsContext = (): UseEventArtistsReturn => {
  const context = useContext(EventArtistsContext);

  if (!context) {
    throw new Error("useEventArtistsContext must be used within an <EventArtistsProvider>.");
  }

  return context;
};

export const useOptionalEventArtistsContext = (): UseEventArtistsReturn | null => {
  return useContext(EventArtistsContext);
};
